<template>
  <div
    class="bottom-bar-item flex w-16 cursor-pointer flex-col gap-2 text-neutral-700 hover:text-primary-500"
    @click="emit('click')"
  >
    <div class="flex flex-row justify-center">
      <slot name="icon" class="h-5 w-5" />
    </div>

    <span class="w-full text-center text-xs font-normal">
      <slot name="label" />
    </span>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  (e: 'click'): void;
}>();
</script>

<style lang="scss">
.active > {
  .bottom-bar-item {
    @apply text-primary-500;
  }
}
</style>
